import React from "react"
import {
  Button,
  Col,
  Form,
  FormFeedback,
  Label,
  Row,
  Toast,
  ToastBody,
} from "reactstrap"
import Spinners from "components/Common/Spinner"
import close from "../../../../assets/images/icons/close.svg"
import BgPatternImage from "../../../../assets/images/background-pattern.png"
import toast from "react-hot-toast"
import { useFormik } from "formik"
import * as Yup from "yup"
import "flatpickr/dist/themes/material_blue.css"
import FlatPickr from "react-flatpickr"

function ApprovePaymentModel({
  data,
  open,
  setOpen,
  isLoading,
  title = "Approve Request",
  description = "Are you sure you want to approve request?",
  onApprove,
  onSuccess,
  onClose,
}) {
  const validation = useFormik({
    initialValues: { date_of_payment: data?.date_of_payment },
    validationSchema: Yup.object({}),

    onSubmit: (values) => {
      handleSend(values)
    },
  })

  const handleSend = async (values) => {
    const { id, investor_id, icd_id, date_of_payment } = data

    try {
      const { success, message } = await onApprove({
        ...values,
        id,
        investor_id,
        icd_id,
      }).unwrap()
      if (success) {
        onSuccess()
        onClose()
        toast.success(message, { id: "toasterMessage" })
      }
    } catch (error) {
      const data = error?.data
      if (data?.errors) {
        const { errors } = data
        validation.setErrors(errors)
      }
      toast.error(error?.data?.message, { id: "toasterMessage" })
    }
  }

  return (
    <>
      {open && <div className="toast-overlay" />}
      <div
        className="position-fixed top-0 start-50 translate-middle-x p-3"
        style={{ zIndex: "99999" }}
      >
        <Toast isOpen={open} role="alert" className="alert-card-box-wrapper">
          <div className="bg-pattern">
            <img src={BgPatternImage} alt="" />
          </div>
          <ToastBody>
            <div className="delete-card-wrapper">
              <div className="inner-box success">
                <i className="mdi mdi-check-circle-outline"></i>
              </div>
              <div>
                <h4>{title}</h4>
                {description}
              </div>
              <div className="close-icon" onClick={() => setOpen(false)}>
                <img src={close} alt="" />
              </div>
            </div>

            <Form
              className="form-horizontal"
              onSubmit={(e) => {
                e.preventDefault()
                validation.handleSubmit()
                return false
              }}
            >
              <Row className="mt-4">
                <Col xl={12} className="mb-2">
                  <Label className="form-label" htmlFor="date_of_payment">
                    Date of Payment
                  </Label>

                  <FlatPickr
                    id="date_of_payment"
                    name="date_of_payment"
                    className={`form-control ${
                      validation.touched.date_of_payment &&
                      validation.errors.date_of_payment &&
                      "is-invalid"
                    }`}
                    placeholder="Select date"
                    options={{
                      dateFormat: "d M, Y",
                      maxDate: new Date(),
                    }}
                    value={validation.values.date_of_payment}
                    onChange={(date) => {
                      const newRepaymentDate = date[0]
                      validation.setFieldValue(
                        "date_of_payment",
                        newRepaymentDate
                      )
                    }}
                  />

                  {validation.errors.date_of_payment &&
                  validation.touched.date_of_payment ? (
                    <FormFeedback type="invalid">
                      {validation.errors.date_of_payment}
                    </FormFeedback>
                  ) : null}
                </Col>
              </Row>
              <div className="mt-3 pt-3 mb-0 button-wrapper buttons position-relative z-2">
                <button
                  onClick={() => onClose()}
                  type="button"
                  className="cancel"
                >
                  Cancel
                </button>
                <Button className="approve btn btn-secondary" type="submit">
                  {isLoading ? <Spinners /> : "Approve Request"}
                </Button>
              </div>
            </Form>
          </ToastBody>
        </Toast>
      </div>
    </>
  )
}

export default ApprovePaymentModel
